import { Component, ViewChild, ElementRef } from '@angular/core';
import { BatchService } from '../Services/batch.service';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../Services/user.service';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { PicklistService } from '../Services/picklist.service';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { Modal } from 'bootstrap';
import { StoreService } from '../Services/store.service';
@Component({
  selector: 'app-batch',
  imports: [HttpClientModule, CommonModule, FormsModule, NgxBarcode6Module],
  templateUrl: './batch.component.html',
  styleUrl: './batch.component.css',
  providers: [BatchService, UserService, StoreService],
})
export class BatchComponent {
  @ViewChild('printSection') printSection!: ElementRef;
  batches: any[] = [];
  userNameMap: { [key: string]: string } = {};
  searchTerm: string = '';
  selectedStatus: string = 'Pending';
  loading = true;
  groupedMedications: any = {};
  batchId: string = '';
  summary: any = [];
  batchDetailModalInstance: Modal | null = null;
  stores: any[] = [];
  selectedStoreId: number | null = null;
  // storeSubject = new Subject<number | null>();
  storeSubject = new BehaviorSubject<number | null>(null);
  todayDate: string = '';
  //pagination
  currentPage: number = 1;
  pageSize: number = 5;
  totalRecords: number = 0;
  statusSubject = new Subject<string>();
  totalPages = 0;
  selectedBatch: any = null;
  isStoreUser = false;
  constructor(
    private _batchservice: BatchService,
    private router: Router,
    private _userservice: UserService,
    private _picklistservice: PicklistService,
    private _storeservice: StoreService,
  ) {}
  ngOnInit() {
    this.todayDate = new Date().toLocaleDateString('en-GB'); // DD/MM/YYYY
    this.listenToFilters();
    this.statusSubject.next(this.selectedStatus);
    const role = this._userservice.checkRole();
    this.isStoreUser = role === 'StoreAdmin' || role === 'StoreUser';
    // if (!this.isStoreUser) {
    //   this.loadStores();
    // }
    if (role === 'Admin') {
      this.loadStores();
    }
  }
  getAllBatch(pageNumber: number = 1) {
    this.loading = true;
    this.currentPage = pageNumber;
    this._batchservice
      .getAllBatch(
        pageNumber,
        this.pageSize,
        this.selectedStatus,
        this.searchTerm,
        this.selectedStoreId,
      )
      .subscribe(
        (response: any) => {
          console.log('response', response);
          this.batches = response.result;
          this.loading = false;
          this.batches.forEach((batch) => this.fetchUserName(batch.userName));
          // this.getTotalBatch();
        },
        (error) => {
          if (error.status === 404) {
            this.batches = []; // Show empty list instead of failing
          } else {
            console.error('Failed to fetch batches:', error);
          }
          this.loading = false;
        },
      );
  }
  loadStores() {
    this._storeservice.getStores().subscribe({
      next: (res: any) => {
        console.log('stores api result:', res);
        this.stores = res.result;
      },
      error: () => {
        console.error('Failed to load stores');
      },
    });
  }
  trackByStoreId(index: number, store: any) {
    return store.storeId;
  }

  // getTotalBatch() {
  //   this._batchservice.getAllBatch(1, 10000, this.selectedStatus, this.searchTerm).subscribe((response: any) => {
  //     this.totalRecords = response.result.length;
  //     this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
  //   });
  // }
  get filteredBatches() {
    if (!this.searchTerm.trim()) return this.batches;
    const term = this.searchTerm.toLowerCase();
    return this.batches.filter((batch) => {
      const mapped = this.userNameMap[batch.userName];
      if (!mapped) return true;
      const [name, ...rest] = mapped.split(',');
      const email = rest.join(' ');
      return (
        name.toLowerCase().includes(term) || email.toLowerCase().includes(term)
      );
    });
  }
  fetchUserName(userName: string) {
    if (!userName || this.userNameMap[userName]) return;
    this._userservice.getUserById(userName).subscribe((response: any) => {
      console.log('r', response);
      this.userNameMap[userName] =
        `${response.result.name},${response.result.email}`;
      console.log('resp', response);
    });
  }
  getMedicationCount(batch: any): number {
    return batch.prescriptions.reduce(
      (total: number, prescription: any) =>
        total + prescription.medications.length,
      0,
    );
  }
  scanBatch(batchId: string) {
    if (this.batchDetailModalInstance) {
      this.batchDetailModalInstance.hide();
      this.batchDetailModalInstance = null;
    }
    this.router.navigate(['/batch', batchId]);
  }
  calculatePendingTime(createdAt: any): string {
    const createdDate = new Date(createdAt);
    const now = new Date();

    const diffMs = now.getTime() - createdDate.getTime();

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(
      (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    let result = '(Pending from ';
    if (diffDays > 0) result += `${diffDays}d `;
    if (diffHours > 0) result += `${diffHours}h `;
    result += `${diffMinutes}m)`;

    return result;
  }
  onStatusChange(status: string) {
    this.statusSubject.next(status);
  }
  onStoreChange(storeId: number | null) {
    this.storeSubject.next(storeId);
  }
  listenToFilters() {
    combineLatest([
      this.statusSubject.pipe(distinctUntilChanged()),
      this.storeSubject.pipe(distinctUntilChanged()),
    ]).subscribe(([status, storeId]) => {
      this.selectedStatus = status;
      this.selectedStoreId = storeId;
      this.currentPage = 1;
      this.batches = [];
      this.getAllBatch(1);
    });
  }
  getUserDisplay(userName: string): { name: string; email: string } {
    const mapped = this.userNameMap[userName];
    if (!mapped) {
      return { name: 'Loading...', email: '' };
    }
    const [name, ...rest] = mapped.split(',');
    return { name, email: rest.join(' ') };
  }
  //print pick list
  printPickList(batchId: string) {
    this.batchId = batchId;
    this._batchservice.getBatchById(batchId).subscribe((response: any) => {
      const batchData = response.result;
      if (batchData) {
        this.groupedMedications =
          this._picklistservice.printPickList(batchData);
        setTimeout(() => this.triggerPrint(), 300);
      }
    });
  }
  triggerPrint() {
    const printContents = this.printSection.nativeElement.innerHTML;
    const popupWin = window.open('', '_blank', 'width=800,height=600');
    if (popupWin) {
      popupWin.document.open();
      // popupWin.document.write(`
      //   <html>
      //     <head>
      //       <title>Print Pick List</title>
      //       <style>
      //         body { font-family: Arial, sans-serif; padding: 20px; }
      //         table { width: 100%; border-collapse: collapse; }
      //         th, td { padding: 8px; text-align: left; }
      //         h2, h4 { margin: 10px 0; }
      //       </style>
      //     </head>
      //     <body onload="window.print(); window.close();">
      //       ${printContents}
      //     </body>
      //   </html>
      // `);
      popupWin.document.write(`
<html>
  <head>
    <title>Batch Pick List</title>
    <style>
      body {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, Arial, sans-serif;
        padding: 20px;
        margin: 0;
        color: #000;
      }

      .print-container {
        width: 100%;
      }

      .print-top-bar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 0;
      }

      .print-date {
        font-size: 13px;
        color: #555;
      }

      .print-logos {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .print-logo {
        height: 36px;
      }

      .print-title {
        margin: 8px 0 14px 0;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 0.2px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      thead th {
        text-align: left;
        padding: 6px 6px;
        border-bottom: 1px solid #e0e0e0;
        font-weight: 700;
        font-size: 14px;
      }

      tbody td {
        padding: 6px;
        border-bottom: 1px solid #e0e0e0;
      }

      tbody tr:last-child td {
        border-bottom: none;
      }

      .col-stock { width: 50%; }
      .col-prescription { width: 25%; }
      .col-qty { width: 10%; }
      .col-picked { width: 15%; }
    </style>
  </head>
  <body onload="window.print(); window.close();">
    ${printContents}
  </body>
</html>
`);

      popupWin.document.close();
    }
  }
  get objectKeys(): (obj: any) => string[] {
    return Object.keys;
  }
  //modal
  openBatchDetailModal(batch: any) {
    this.selectedBatch = batch;
    const modalElement = document.getElementById('batchDetailModal');
    if (modalElement) {
      this.batchSummary(this.selectedBatch);
      console.log('batchde', this.selectedBatch);
      this.batchDetailModalInstance = new Modal(modalElement);
      this.batchDetailModalInstance.show();
    }
  }
  //batch summary
  // batchSummary(batch: any) {
  //   // console.log(batch);

  //   let totalPrescription = 0;
  //   let totalMedicines = 0;
  //   const patientSummaries: any[] = [];

  //   batch.prescriptions.forEach((prescription: any) => {
  //     totalPrescription++;
  //     const patientName = prescription.patientName
  //     const medicationCount = prescription.medications?.length || 0;
  //     totalMedicines += medicationCount;

  //     patientSummaries.push({
  //       patientName,
  //       medicationCount
  //     });
  //   });

  //   this.summary = {
  //     totalPrescription,
  //     totalMedicines,
  //     patientSummaries
  //   };
  // }

  //   batchSummary(batch: any) {
  //   const patientSummaries: any[] = [];

  //   batch.prescriptions.forEach((prescription: any) => {
  //     const medications = prescription.medications.map((med: any) => ({
  //       medicationName: med.medicationName,
  //       dosage: med.dosage,
  //       isAvailable: med.isAvailable
  //     }));

  //     patientSummaries.push({
  //       patientName: prescription.patientName,
  //       medications
  //     });
  //   });

  //   this.summary = {
  //     patientSummaries
  //   };
  // }

  batchSummary(batch: any) {
    const patientSummaries: any[] = [];

    batch.prescriptions.forEach((prescription: any) => {
      patientSummaries.push({
        patientName: prescription.patientName,
        medications: prescription.medications.map((med: any) => ({
          medicationName: med.medicationName,
          dosage: med.dosage,
          isAvailable: med.isAvailable,
        })),
        expanded: false,
      });
    });

    this.summary = {
      patientSummaries,
    };
  }

  togglePatient(patient: any) {
    patient.expanded = !patient.expanded;
  }
  getLastChars(id: string): string {
    if (!id) return '';
    return id.slice(-8); // change to -10 if you prefer
  }
}
